import React from "react";
import { AuthProvider } from "./authContext";
import { DevicesProvider } from "./devicesContext";

interface Props {
  children: React.ReactNode;
}

const AppProviders: React.FC<Props> = ({ children }) => {
  return (
    <AuthProvider>
      <DevicesProvider>
        {children}
      </DevicesProvider>
    </AuthProvider>
  );
};

export default AppProviders;
